module.exports = __webpack_public_path__ + "media/application/images/icons/arrow_forward-b16797c7052a4f4bf85533fc356cb127.svg";